import dynamic from 'next/dynamic'
import { BogoBanner } from '@mc/bogo'
import { PAGE_SOURCES, PromoExplainerModal } from '@mc/promos'
import { StickyFooter } from 'components/StickyFooter'
import {
  PageDataProvider,
  CategoryNavCarousel,
} from 'pages/categories/CategoryPage/components'
import { Meta } from 'pages/categories/components'
import { CategoryPageProps } from 'pages/categories/pageProps'
import { Hero } from './components/Hero'

const BelowTheFold = dynamic(
  () => import('./components/BelowTheFold').then((m) => m.BelowTheFold),
  { ssr: false },
)

export const AllCategoryPage = ({
  slug,
  category,
  categories,
  subcategories,
  courses,
  instructors,
  coursesOutcomes,
  subcatsCoursesOutcome,
}: CategoryPageProps) => {
  if (!subcategories) {
    return null
  }

  return (
    <PageDataProvider
      value={{
        categories,
        slug,
        subcategories,
        category,
        courses,
        instructors,
        coursesOutcomes,
        subcatsCoursesOutcome,
      }}
    >
      <Meta />
      <BogoBanner className='mc-mb-2' />
      <PromoExplainerModal pageSource={PAGE_SOURCES.CATEGORY_PAGE} />
      <div className='container'>
        <div className='mc-mb-6'>
          <CategoryNavCarousel />
        </div>
        <Hero />
      </div>
      <BelowTheFold />
      <StickyFooter />
    </PageDataProvider>
  )
}
